import { Observable } from 'rxjs';
import { DialogComponent } from '../dialog/dialog.component';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Injectable } from '@angular/core';

@Injectable()
export class DialogsService {

  constructor(private dialog: MatDialog) { }

  public confirm(errors: Array<string>): Observable<boolean> {

    let dialogRef: MatDialogRef<DialogComponent>;

    dialogRef = this.dialog.open(DialogComponent);
    dialogRef.componentInstance.errors = errors;

    return dialogRef.afterClosed();
  }
}
